import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { customListSchemaApi, customListUsableFieldApi } from '../apis';
import CustomListInfo from './CustomListInfo';
import { useDispatch } from 'react-redux';
import {
  fetchCustomListSchemaSuccess,
  fetchUsableMonitoringFieldsSuccess,
  fetchUsableScreeningFieldsSuccess,
} from './customListReducer';
import CustomListUsableFields from './usableFields/CustomListUsableFields';
import useCustomLists from './useCustomLists';
import SchemaFields from './schema/SchemaFields';
import CustomListSignificantFields from './significantFields/CustomListSignificantFields';
import './CustomListSettings.scss';
import SalvPage from '../common/SalvPage';

export const CustomListSettings = () => {
  const customListId = useParams().customListId!;
  const dispatch = useDispatch();

  const customList = useCustomLists().find((list) => list.id === customListId);

  useEffect(() => {
    (async () => {
      const schema = await customListSchemaApi.getCustomListSchema({
        customListId: customListId!,
      });
      dispatch(fetchCustomListSchemaSuccess(schema.schemaFields));
    })();
    (async () => {
      const fields = await customListUsableFieldApi.getScreeningFields({
        customListId: customListId!,
      });
      dispatch(fetchUsableScreeningFieldsSuccess(fields));
    })();
    (async () => {
      const fields = await customListUsableFieldApi.getMonitoringFields({
        customListId: customListId!,
      });
      dispatch(fetchUsableMonitoringFieldsSuccess(fields));
    })();
  }, []);

  return (
    <SalvPage
      title={'List settings'}
      breadcrumb={{ title: 'Custom list', to: `/custom-lists/${customList?.id}` }}
      className='bootstrap-card custom-list-settings'
    >
      <CustomListInfo customList={customList} />
      <SchemaFields customListId={customListId} canEdit={customList?.canEdit ?? false} />
      <CustomListSignificantFields customListId={customListId} />
      <CustomListUsableFields canEdit={customList?.canEdit ?? false} />
    </SalvPage>
  );
};

export default CustomListSettings;
